import React from 'react';

/**
 * Un mot qui existe d'abord au trait, puis se remplit — le wireframe devenu
 * interface, joué sur le nom lui-même.
 *
 * Le mot réel reste dans le document, en transparent : c'est lui que lisent
 * les lecteurs d'écran et les moteurs. Les deux calques peints sont des
 * pseudo-éléments, invisibles à l'arbre d'accessibilité.
 *
 * Les variables valent 1 par défaut : sans JavaScript, le nom s'affiche plein.
 */
const TracedWord = ({ text, className = '' }) => (
  <span className={`trace-mot ${className}`} data-mot={text}>
    {text}
  </span>
);

export default TracedWord;
